export default {
	"DetailList.LongPressToIdentifyTheQRCode": "长按识别二维码",
	"DetailList.enter": "进入",
	"DetailList.TheAppletViewsTheContent": "小程序查看内容",
	"DetailList.TheFollowingItemsAreIncluded": "包含以下商品",
	"DetailList.Gifts": "赠品",
	"DetailList.Real": "实物"
}